import styled, { css } from 'styled-components';
import { themeGet, getBackgroundColor } from '@magalu/stereo-ui-styles';
import { Heading, Flex } from '../../atoms';
import AlertText from '../../molecules/AlertText';
const ALERT_COLORS = {
  warning: '#fed34e',
  error: '#E41C41'
};
const ALERT_TEXT_COLORS = {
  warning: '#1E2428E5'
};

const handleAlertColor = props => ALERT_TEXT_COLORS[props.type] || getBackgroundColor('lighter')(props);

const handleAlertBackground = props => ALERT_COLORS[props.type] || getBackgroundColor('primary')(props);

const BaseContainer = styled(Flex)`
  flex-direction: column;
  border-radius: 8px;
  gap: 24px;
  background-color: ${themeGet('palette.background.lighter')};
`;
export const Container = styled(BaseContainer)`
  width: 100%;
  margin-top: ${({
  marginTop
}) => marginTop || '8px'};
  ${({
  withBorder
}) => withBorder && css`
      border: 1px solid #d3dadd;
    `}
`;
export const AlertContent = styled(BaseContainer)`
  width: 100%;

  svg {
    min-width: 24px;
  }
`;
export const CustomAlertText = styled(AlertText).attrs(props => Object.assign({
  styleContainer: {
    backgroundColor: handleAlertBackground(props),
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px'
  },
  styleMessage: {
    fontSize: `${themeGet('fontSizes.')(props)}px`,
    fontWeight: themeGet('fontWeights.regular')(props),
    lineHeight: `${themeGet('lineHeights.tall')(props)}px`,
    color: handleAlertColor(props),
    padding: '15px 24px'
  }
}, props))``;
export const CardTitle = styled(Heading)`
  font-weight: ${themeGet('fontWeights.bold')};
  font-size: ${themeGet('fontSizes.2')}px;
`;
export const CardBody = styled(Flex)`
  flex-direction: ${({
  isRow
}) => isRow ? 'row' : 'column'};
  width: 100%;
  gap: 24px;
`;
export const CardContent = styled(Flex)`
  flex-direction: column;
  padding: 24px;
  gap: 24px;
  width: 100%;

  ${({
  isAlert
}) => isAlert && css`
      padding-top: 0;
    `}
`;